import React from "react";
import { MimaText, Modal } from "../../components";

const ViewTodo = ({ closeModal, item, tradingName }) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={3}>
        {` Todo Information for ${tradingName}`}
      </MimaText>
      <div>
        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            Number of customers added:
          </MimaText>
          <MimaText>{item?.todo?.addedCustomers}</MimaText>
        </div>

        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            Number of measurements added:
          </MimaText>
          <MimaText>{item.todo.addedMeasurements}</MimaText>
        </div>

        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            Number of Styles added:
          </MimaText>
          <MimaText>{item.todo.addedStyles}</MimaText>
        </div>

        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            User has created website:
          </MimaText>
          <MimaText>{item.todo.createdWebsite ? "Yes" : "No"}</MimaText>
        </div>

        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            User has set Brand info:
          </MimaText>
          <MimaText>{item.todo.setBrandInfo ? "Yes" : "No"}</MimaText>
        </div>

        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            User has set transaction pin:
          </MimaText>
          <MimaText>{item.todo.setTransactionPin ? "Yes" : "No"}</MimaText>
        </div>

        <div className="modal__beside">
          <MimaText variant="body" mb={2} color="var(--color-primary)">
            User has set withdrawal account:
          </MimaText>
          <MimaText>{item.todo.setWithdrawalAccount ? "Yes" : "No"}</MimaText>
        </div>
      </div>
    </Modal>
  );
};
export default ViewTodo;
